export default "__VITE_ASSET__hSc14bAa__"